import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-eskiin-policy.js';

const img1 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe38e8ebbce08ea5021745.webp?w=50&h=50&q=80';
const img2 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe38effb4b9f7a07b8f4fc.webp?w=50&h=50&q=80';
const img3 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe38f55f705836c24207a4.webp?w=50&h=50&q=80';
const img4 = 'https://cdn.skyfastimg.com/images/2026/10/01/image-6abe38fb89a429cb21133763.webp?w=50&h=50&q=80';

const defaultItems = [
  {
    image: img1,
    title: '<p>Dermatologist</p><p>Recommended</p>',
  },
  {
    image: img2,
    title: `<p>Free</p><p>Delivery</p>`,
  },
  {
    image: img3,
    title: `<p>60 Day Money</p><p>Back Guarantee</p>`,
  },
  {
    image: img4,
    title: `<p>Secure</p><p>Checkout</p>`,
  },
];

const renderItem = item => `
  <div class="item-sm" data-attribute="item">
    <div class="wrap-img">
      <img data-attribute="item-image" src="${item.image}" alt="" />
    </div>
    <div class="item-title" data-attribute="item-title">${item.title}</div>
  </div>`;

const contentHtml = `
<div class="list-item" data-attribute="list-item">${defaultItems.map(renderItem).join('')}
</div>
`;
export default containerFuild(contentHtml, css, {
  backgroundColor: '#F7F7F7FF',
});
